import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Avatar, Box, Tooltip, IconButton } from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";

interface AgentAvatarProps {
    onClick: () => void;
    isOpen: boolean;
}

const AgentAvatar: React.FC<AgentAvatarProps> = ({ onClick, isOpen }) => {
    return (
        <Box
            component={motion.div}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                zIndex: 9999,
            }}
        >
            <Tooltip title="Need help? Click me!" placement="left">
                <IconButton
                    onClick={onClick}
                    sx={{
                        width: 56,
                        height: 56,
                        bgcolor: "primary.main",
                        color: "white",
                        boxShadow: 6,
                        "&:hover": {
                            bgcolor: "primary.dark",
                        },
                    }}
                >
                    <SmartToyIcon fontSize="large" />
                </IconButton>
            </Tooltip>

            {/* Pulse effect */}
            <Box
                component={motion.div}
                animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.5, 0, 0.5],
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                }}
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: "50%",
                    border: "2px solid",
                    borderColor: "primary.main",
                    zIndex: -1,
                }}
            />
        </Box>
    );
};

export default AgentAvatar;
